
<a class="nav-link" matRipple (click)="toggleOpen($event)">
    <mat-icon class="material-icons-outlined nav-link-icon" *ngIf="item.icon">{{item.icon}}</mat-icon>
    <span class="nav-link-title">{{item.title}}</span>
    <mat-icon class="collapse-arrow">keyboard_arrow_right</mat-icon>
</a>
<div class="children" [@slideInOut]="isOpen">
    <ng-container *ngFor="let item of item.children">
        <wtf-nav-vertical-item *ngIf="item.type=='item'" [item]="item"></wtf-nav-vertical-item>
        <wtf-nav-vertical-collapse *ngIf="item.type=='collapse'" [item]="item"></wtf-nav-vertical-collapse>
        <wtf-nav-vertical-group *ngIf="item.type=='group'" [item]="item"></wtf-nav-vertical-group>
    </ng-container>
</div>

